const contactedViaDealTranslate: Record<string, string> = {
  'CONTACT.VIA.CHILEAUTOS': 'Chileautos',
  'CONTACT.VIA.EMAIL': 'Email',
  'CONTACT.VIA.FACE_TO_FACE': 'En persona',
  'CONTACT.VIA.INSTAGRAM': 'Instagram',
  'CONTACT.VIA.MARKETPLACE': 'Marketplace (Facebook)',
  'CONTACT.VIA.MERCADOLIBRE': 'Mercado libre',
  'CONTACT.VIA.WEB_PAGE': 'Página Web',
  'CONTACT.VIA.PHONE': 'Teléfono',
  'CONTACT.VIA.WHATSAPP': 'WhatsApp',
  'CONTACT.VIA.YAPO': 'Yapo',
  //"CONTACT.VIA.SOCIAL_NETWORK": "Red social",

  'CONTACT.VIA.SELLER_WEB': 'Vendedor web',
  'CONTACT.VIA.OTHER': 'Otra',
}

export default contactedViaDealTranslate
